export default __webpack_public_path__ + "static/accenture-detail-2-a967d07fbef0aa039b5a2bab2debfc61.jpg";